import React, { useState } from 'react';
import { Section } from './Section';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: 'When do I receive the product?',
  a: "Immediately. As soon as you complete your purchase, you'll receive the download link by email. You can read it during this very nap."
}, {
  q: 'Is it physical or digital?',
  a: '100% digital. No shipping, no waiting. Yours forever on your phone, tablet, or computer.'
}, {
  q: 'How long will it take me to use it?',
  a: 'Less than 5 minutes to see the full plan. Designed for moms with one free hand and zero energy.'
}, {
  q: 'Is this cry-it-out?',
  a: "No. This system never involves leaving your baby to cry alone. You respond to every cue. The focus is on structuring your day, not changing your baby's sleep."
}, {
  q: 'What age is this for?',
  a: 'Designed for parents of newborns 0–3 months, but adaptable through 6 months.'
}, {
  q: 'What if my baby screams when put down?',
  a: 'You pick them up. The gentle exposure steps are gradual — even 5 seconds of crib time counts as progress. No forcing.'
}, {
  q: 'Is this medically safe?',
  a: 'This is educational guidance about parental structure, not medical advice. Always consult your pediatrician for health concerns.'
}, {
  q: 'What if I only gain 10 minutes?',
  a: '10 minutes of protected time is a real win. Most parents in survival mode have zero. The system builds from there.'
}, {
  q: "What if my partner won't help?",
  a: 'The guide includes specific scripts and micro-asks designed to get buy-in without conflict. Many parents start solo and bring their partner in gradually.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <Section alternate data-id="element-193">
      <h2 className="font-serif text-3xl md:text-4xl text-brown mb-12 text-center" data-id="element-194">
        Frequently Asked Questions
      </h2>

      <div className="max-w-2xl mx-auto space-y-4" data-id="element-195">
        {faqs.map((faq, i) => <div key={i} className="border border-brown/10 rounded-xl overflow-hidden bg-white" data-id="element-196">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left hover:bg-cream/50 transition-colors" data-id="element-197">
              <span className="font-serif text-lg text-brown font-medium pr-4" data-id="element-198">
                {faq.q}
              </span>
              <ChevronDown className={`w-5 h-5 text-terracotta transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-199" />
            </button>
            <AnimatePresence data-id="element-200">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-201">
                  <div className="p-6 pt-0 text-brown-light leading-relaxed border-t border-brown/5" data-id="element-202">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}